import ButtonPrimary from '../common/components/Button/ButtonPrimary.js'
import reloadApp from '../common/reloadApp.js'
import {loadingDataErrorSelector} from '../data/Data.js'
import {useSelector} from '../store.js'

export default function AppLoadErrorMessage() {
  const loadingDataError = useSelector(loadingDataErrorSelector)
  const message = loadingDataError.error_message || loadingDataError.message

  return (
    <div className="wrap--row margin-top-25 padding-top-25">
      <div className="medium-5 columns medium-centered">
        <div className="alert alert--error alert--lg full-border align-center">
          <p className="fs-01 lh-md margin-bottom-15">
            <strong>
              Ordoro encountered this error and could not be loaded:
            </strong>
          </p>
          <pre className="alert alert--neutral alert--lg no-bg fs-n0 break-spaces lh-md margin-left-20 margin-right-20 margin-bottom-20">
            {message}
          </pre>
          <ButtonPrimary isOutlined size="md" onClick={() => reloadApp()}>
            <strong>Reload the Page</strong>
          </ButtonPrimary>
        </div>
      </div>
    </div>
  )
}
